import React, { useEffect, useState } from 'react'
import { Card, Table, Form, Input, Space, Button, Pagination, Select } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { getAllocationLogListAPI, getAllFollowUpUserListAPI } from '@/apis/user'
import { checkMenu, checkLogin } from '@/utils'
// import { useParams } from 'react-router-dom'
import Dayjs from 'dayjs'
const { Column } = Table

export default function AllocationLogList() {
  const navigate = useNavigate()
  const location = useLocation()
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    keywords: '',
    followUpUserId: undefined,
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  列表总数
  const [list, setList] = useState()
  const [followUpUserList, setFollowUpUserList] = useState([]) // 全部跟进人列表

  //  获取分客记录列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    listQuery.followUpUserId = listQuery.followUpUserId || 0
    const res = await getAllocationLogListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.operateTime = Dayjs(item.operateTime).format('YYYY-MM-DD HH:mm')
          item.nickName = decodeURIComponent(item.nickName) ? item.nickName : '暂无昵称' + item.userId.toString().slice(-4)
          item.key = index + 1
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }
  //  获取全部跟进人列表
  const getAllFollowUpUserList = async () => {
    const res = await getAllFollowUpUserListAPI()
    if (res.success === true) {
      let followUpUserList = []
      res.result?.list?.forEach(item => {
        if(item.status === 1) {
          followUpUserList.push({
            value: item.userId,
            label: item.nickName
          })
        }
      })
      setFollowUpUserList(followUpUserList)
    }
  }
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  // 搜索
  const searchFinish = values => {
    console.log('%c [ values ]-77', 'font-size:13px; background:pink; color:#bf2c9f;', values)
    listQuery.followUpUserId = values.followUpUserId ? values.followUpUserId : 0
    listQuery.keywords = values.keywords || ""
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
    getAllFollowUpUserList()
  }, [])
  return (
    <div>
      <div className="pageTitle">分客记录</div>
      <Card className="card">
        <Form initialValues={listQuery} onFinish={searchFinish} className="searchForm">
          <Form.Item name="keywords">
            <Input allowClear placeholder="用户电话" style={{ width: '200px', marginLeft: '10px' }} />
          </Form.Item>
          <Form.Item name="followUpUserId">
            <Select allowClear options={followUpUserList} placeholder="跟进人" style={{ width: '250px', marginLeft: '10px' }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="searchBtn" htmlType="submit" style={{ marginLeft: '10px' }}>
              搜索
            </Button>
          </Form.Item>
        </Form>
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column title="被分配用户" dataIndex="nickName" />
          <Column title="被分配用户电话" dataIndex="mobile" />
          <Column title="接收人" dataIndex="followUpNickName" />
          <Column
            title="分配操作账号"
            render={(_, record) => (
              <Space size="middle">
                {record.platform ? '' : 'PC端，'}
                {record.operateNickName}
              </Space>
            )}
          />
          <Column title="操作时间" dataIndex="operateTime" />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
    
  )
}
